/**
 * Use this function for getting the last 4 digits of any card number
 * and validate the scenario when the backend casting
 * returns 3 or less digits (adding 0's at the beginning).
 */
const getLastFourDigits = (cardNumber) => {
  if (!cardNumber) {
    return cardNumber;
  }

  const response = String(cardNumber);
  return response.slice(-4).padStart(4, '0');
};

export {
  getLastFourDigits,
};
